import { useOutletContext } from "react-router-dom";
import { Policy } from "~/operations";
import { PolicyAssignScope } from "../utils";

export type PolicyOutletContextType = {
  scope: PolicyAssignScope;
  policy: Partial<Policy>;
  policyId: string;
};

export function usePolicyOutletContext() {
  return useOutletContext<PolicyOutletContextType>();
}
